import { ImplementorTemplateParams } from "components/stories/video-studio/utils/creatomate/setCustomTemplate";
import deleteElement from "components/stories/video-studio/utils/creatomate/deleteElement";
import syncMediaElements from "components/stories/video-studio/utils/creatomate/syncMediaElements";
import { ELEMENT_NAMES } from "components/stories/video-studio/utils/constants";
import { cacheAssetIfNeeded, calculateVideoDuration } from "../../utils/utils";
import findElementByName from "../../utils/findElementByName";

const recognitionWeekOverlayOrange = async ({
  preview,
  mediaElements,
  defaultVideoProperties,
  story
}: ImplementorTemplateParams) => {
  cacheAssetIfNeeded(preview, story);

  const json = preview.getSource();
  const elements = json?.elements;

  const storyVideoElement = findElementByName(elements, ELEMENT_NAMES.STORY);

  const heightProportion = (story?.media?.height || 1) / (preview.state?.height || 720);
  const mediaWidth = (
    100 * ((story?.media?.width || 1) / heightProportion)
  ) / (preview.state?.width || 1280);

  await syncMediaElements(preview, mediaElements, {
    ...defaultVideoProperties,
    track: storyVideoElement?.track,
    width: `${mediaWidth}%`
  }, 0);
  await deleteElement(preview, storyVideoElement?.id);
  const videoDuration = calculateVideoDuration(mediaElements);

  await preview.applyModifications({ duration: videoDuration });
};

export default recognitionWeekOverlayOrange;
